import { Heading, Para } from 'ui-components';
import StylistList from './StylistList';
import { CompleteStoreFragment } from 'drycut-graphql';
import { StoreWaitingTime } from 'controlled-components';
import { MAX_MINUTES_TO_DISPLAY } from 'ui-format-utils';

type Props = {
  store: CompleteStoreFragment;
};

export default function StepWaitingTime({ store }: Props): React.ReactElement {
  const longerWait = store.waitingTime > MAX_MINUTES_TO_DISPLAY * 60;

  return (
    <>
      {!longerWait ? (
        <Para>Buche jetzt den nächsten verfügbaren Slot in</Para>
      ) : (
        <Para className="text-xl lg:text-base">Nächster freier Termin</Para>
      )}

      <Heading variant="h3" className="mb-2">
        <StoreWaitingTime store={store} showCa showZero steps />
        {!longerWait && <StylistList stylists={store.checkedInStylists} />}
      </Heading>
    </>
  );
}
